<template >
    
    <div class="container-fluid" >

        <div v-if="object">
            

            <div class="card shadow mb-4" >
                <div class="card-header py-3">
                <h1>{{object.name}}</h1>
                <h1>{{object.title}}</h1>
           
                </div>
                <div class="card-body" >
                     <p>{{object.description}}</p>
                    <div class="row  text-center text-lg-left" v-if="object.images!=null && object.images.length>0">
                        <div class="col-lg-3 col-md-4 col-6" v-for="(file, index) in object.images" v-bind:key="file.fileUrl">
                            <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" :src="file.fileUrl" @click="deleteFile(file, index)"/>
                            </a>
                        </div>
                    </div>
                    <div v-else>
                        <div class="alert alert-warning">Одоогоор зураг ороогүй байна.</div>
                    </div>
                        <div >
                            <div>

                            <input type="file"   ref="file" @change="uploadFile1" accept="image/*" >
                        
                            <div class="progress" v-if="uploading">
                                <div class="progress-bar" role="progressbar" v-bind:style="{ width: uploadPercent + '%' }" aria-valuemin="0" aria-valuemax="100">{{uploadPercent.toFixed()}}%</div>
                            </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>

    </div>
    
</template>

<script>
const fb = require("../firebaseConfig.js");
export default {
  name: "ImageAdd",
  data() {
    return {

      object:null,

      'uploading':false,
      'uploadPercent':null,
      bucket: 'images/'

    };
  },
  created() {
    if(this.objectPath!=null && this.objectPath!=''){
      this._getTour();
    }
  },
  methods: {

    async _getTour(){

      var tourData=await fb.db.doc(this.objectPath).get();
        let object=tourData.data()
        object.id=tourData.id
        this.object=object
 
      
    },
    uploadFile1(){

        var _this=this;
        var files = this.$refs['file'].files

        if(files!=null && files.length>0){
          var file=files[0]
          var now=new Date();
          var fileName=+now.getTime()+"_"+file.name;
          var uploadTask = fb.storageRef.child(this.bucket+ fileName).put(file);
          _this.uploading=true
          _this.uploadPercent=0
          uploadTask.on(fb.storage.TaskEvent.STATE_CHANGED,
            function(snapshot) {
              var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              _this.uploadPercent=progress
            }, function(error) {
            switch (error.code) {
              case 'storage/unauthorized':
                break;

              case 'storage/canceled':
                break;


              case 'storage/unknown':
                break;
            }
          }, 
          function() {
            uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
              
              let fileObject={
                'fileName': fileName,
                'fileUrl':downloadURL,
                'uploadedAt': now
              }
              fb.db.doc(_this.objectPath).update(
                {
                    images: fb.firestore.FieldValue.arrayUnion(fileObject)
                }
              )

              if(_this.object!=null){
                if(_this.object.images==null)
                  _this.object.images=[]
                _this.object.images.push(fileObject)
              }
              _this.uploading=false,
              _this.uploadPercent=null

              _this.$refs['file'].value = ''

              if(!/safari/i.test(navigator.userAgent)){
                _this.$refs['file'].type = ''
                _this.$refs['file'].type = 'file'
              }
            });
          });
        }
        
      },
      deleteFile(file, index){
        var result = confirm("Та "+file.fileName+" файлыг устгах уу?");
          if (result) {
            var fileRef = fb.storageRef.child(this.bucket+ file.fileName);
            fileRef.delete().then(() =>{
              this.object.images.splice(index, 1);
              fb.db.doc(this.objectPath).update({
                  images: this.object.images
                }
              )
            }).catch(function(error) {

            });
              
          }
      }
  },
  props: {
      objectPath: { 
          required: true,
      }
  },
};
</script>
